import type { User } from '../types';

export const canAccessOwnClubManagement = (user: User | null | undefined): boolean =>
  Boolean(user?.club_id && (user.role === 'admin' || user.role === 'club-manager'));

export const canAccessClubDetail = (user: User | null | undefined, clubId: string | null | undefined): boolean =>
  canAccessOwnClubManagement(user) && Boolean(clubId) && user?.club_id === clubId;
